var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchableTable',{attrs:{"panel-header":'Personen',"panel-route":'AddPerson',"show-search-bar":true,"table-data":_vm.persons,"table-meta-data":_vm.tableMetaData,"query-string":'setPersonSearchQuery',"initial-search-query":_vm.personSearchQuery,"row-click":_vm.triggerView,"default-sort":['attributes.last_name', 'asc']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }